import React from 'react';
import EmptyActivities from './components/EmptyActivities';
import RecentActivities from './components/RecentActivities';
import { useLoggedOutAthletePageContext } from '../../state/LoggedOutAthletePageContext';

const Activities = () => {
  const { state } = useLoggedOutAthletePageContext();
  const { athleteData } = state;
  const { recentActivities } = athleteData;

  const hasActivities = recentActivities && recentActivities.length > 0;

  return hasActivities ? <RecentActivities /> : <EmptyActivities />;
};

export default Activities;
